const body = document.querySelector('body');
const backDrop = document.querySelector('.backdrop');
const popUp = document.querySelectorAll('.popUp');
const popUpArea = document.querySelector('.cases__examples');
const popUpCloseBtn = document.querySelectorAll('.popUp__closeBtn');

class PopUp {
  constructor() {
    this.popUpOpenBtnClick();
    this.popUpCloseBtnPopUp();
    this.closePopUp();
  }

  popUpOpenBtnClick() {
    popUpArea.addEventListener('click', function (e) {
      const clickedCase = e.target.closest('.cases__example');

      if (!clickedCase) return;
      backDrop.classList.add('isActive');
      document
        .querySelector(`.popUp-${clickedCase.dataset.popup}`)
        .classList.add('isActive');
      body.classList.add('body-no-scroll');
    });
  }

  popUpCloseBtnPopUp() {
    backDrop.addEventListener('click', this.closePopUp);
    popUpCloseBtn.forEach((btn) => {
      btn.addEventListener('click', this.closePopUp);
    });
  }

  closePopUp() {
    backDrop.classList.remove('isActive');
    popUp.forEach((el) => {
      el.classList.remove('isActive');
    });
    body.classList.remove('body-no-scroll');
  }
}
export default PopUp;
